
import { AfterViewInit, Directive, ElementRef, OnDestroy, inject, output, DOCUMENT } from '@angular/core';
import { ReplaySubject, Subscription, fromEvent } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[appClickOutside]'
})
export class ClickOutsideDirective implements AfterViewInit, OnDestroy {
  private element = inject(ElementRef);
  private document = inject<Document>(DOCUMENT);


  // Update output to use Angular 20 output() function
  clickOutside = output<void>();

  documentClickSubscription!: Subscription;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  ngAfterViewInit(): void {
    this.documentClickSubscription = fromEvent(this.document, 'click')
      .pipe(
        filter((event) => {
          return !this.isInside(event.target as HTMLElement);
        }),
        takeUntil(this.destroyed$)
      )
      .subscribe(() => {
        this.clickOutside.emit();
      });
  }

  isInside(elementToCheck: HTMLElement): boolean {
    return (
      elementToCheck === this.element.nativeElement ||
      this.element.nativeElement.contains(elementToCheck)
    );
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

}




